import React from 'react';
import '../styles/LoadingSkeleton.css';

// Base Skeleton
export const Skeleton = ({ width = '100%', height = '20px', circle = false, className = '' }) => {
  return (
    <div 
      className={`skeleton ${circle ? 'skeleton-circle' : ''} ${className}`}
      style={{ width, height }}
    />
  );
};

// Card Skeleton (for matrimony cards, news cards)
export const CardSkeleton = () => {
  return (
    <div className="skeleton-card">
      <Skeleton height="200px" className="skeleton-card-image" />
      <div className="skeleton-card-body">
        <Skeleton width="60%" height="24px" className="mb-2" />
        <Skeleton width="40%" height="16px" className="mb-3" />
        <Skeleton width="100%" height="14px" className="mb-2" />
        <Skeleton width="90%" height="14px" className="mb-2" />
        <Skeleton width="80%" height="14px" />
      </div>
    </div>
  );
};

// Profile Card Skeleton (circular photo style)
export const ProfileCardSkeleton = () => {
  return (
    <div className="skeleton-profile-card">
      <Skeleton width="150px" height="150px" circle className="mx-auto mb-3" />
      <Skeleton width="70%" height="20px" className="mx-auto mb-2" />
      <Skeleton width="50%" height="16px" className="mx-auto mb-2" />
      <Skeleton width="60%" height="14px" className="mx-auto" />
    </div>
  );
};

// List Item Skeleton
export const ListItemSkeleton = () => {
  return (
    <div className="skeleton-list-item">
      <Skeleton width="60px" height="60px" circle />
      <div className="skeleton-list-content">
        <Skeleton width="80%" height="18px" className="mb-2" />
        <Skeleton width="60%" height="14px" />
      </div>
    </div>
  );
};

// Post Detail Skeleton
export const PostDetailSkeleton = () => {
  return (
    <div className="skeleton-post-detail">
      <Skeleton width="100%" height="400px" className="mb-4" />
      <Skeleton width="90%" height="36px" className="mb-3" />
      <Skeleton width="40%" height="16px" className="mb-4" />
      <Skeleton width="100%" height="16px" className="mb-2" />
      <Skeleton width="100%" height="16px" className="mb-2" />
      <Skeleton width="95%" height="16px" className="mb-2" />
      <Skeleton width="100%" height="16px" className="mb-2" />
      <Skeleton width="85%" height="16px" />
    </div>
  );
};

// Form Skeleton
export const FormSkeleton = () => {
  return (
    <div className="skeleton-form">
      <Skeleton width="30%" height="16px" className="mb-2" />
      <Skeleton width="100%" height="45px" className="mb-4" />
      
      <Skeleton width="30%" height="16px" className="mb-2" />
      <Skeleton width="100%" height="45px" className="mb-4" />
      
      <Skeleton width="30%" height="16px" className="mb-2" />
      <Skeleton width="100%" height="120px" className="mb-4" />
      
      <Skeleton width="150px" height="45px" />
    </div>
  );
};

// Grid Skeleton (for multiple cards)
export const GridSkeleton = ({ count = 6, CardComponent = CardSkeleton }) => {
  return (
    <div className="row g-4">
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="col-lg-4 col-md-6">
          <CardComponent />
        </div>
      ))}
    </div>
  );
};

// Profile Grid Skeleton
export const ProfileGridSkeleton = ({ count = 6 }) => {
  return (
    <div className="row g-4">
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="col-lg-2 col-md-3 col-sm-6">
          <ProfileCardSkeleton />
        </div>
      ))}
    </div>
  );
};

export default {
  Skeleton,
  CardSkeleton,
  ProfileCardSkeleton,
  ListItemSkeleton,
  PostDetailSkeleton,
  FormSkeleton,
  GridSkeleton,
  ProfileGridSkeleton
};